<!-- <div class="bg-gray-100 font-sans antialiased min-h-screen pb-12">
  <div class="flex flex-col lg:flex-row">
      <div class="flex items-center justify-center mt-5 lg:ml-10">
          <img alt="Logo" class="h-24 w-48 lg:h-24 lg:w-60" src="assets/companyLogo.png" />
      </div>
      <div class="flex flex-col lg:flex-row justify-between items-center mb-6 w-full lg:w-full px-4 lg:px-0"> -->
          <!-- Add menu toggle button for desktop -->
          <!-- <div class="lg:ml-80"></div>
          <div class="flex items-center lg:ml-96 lg:mr-8 space-x-8 lg:space-x-10 sm:mt-4 lg:mt-0">
              <i class="fas fa-bell text-purple-700 relative">
                  <span class="absolute top-0 right-0 inline-block w-2 h-2 bg-red-600 rounded-full"></span>
              </i>
              <i class="fas fa-envelope text-gray-400"></i>
              <i class="fas fa-user text-gray-400" ></i>
              <i class="fas fa-sign-out-alt text-gray-400 text-xl cursor-pointer" (click)="onLogoutClick()"></i>
              <i class="fas fa-bars text-purple-700 text-xl font-bold cursor-pointer " (click)="toggleMenu()">
              </i>
          </div>
      </div>
    </div>
  <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-80 bg-gray-200 lg:ml-10 shadow-lg p-6" [class.hidden]="!menuOpen">
          <nav class="mt-4 lg:mt-10">
              <a class="flex items-center py-3 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onHomeClick()">
                  <i class="fas fa-home text-purple-600"></i>
                  <span class="mx-4 font-medium">Home</span>
                  <i class="fas fa-caret-down ml-auto"></i>
              </a>
              <a class="flex items-center py-3 mt-4 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onReportClick()">
                  <i class="fas fa-clipboard-list text-purple-600"></i>
                  <span class="mx-4 font-medium">Reports</span>
                  <i class="fas fa-caret-down ml-auto"></i>        
              </a>
              <a class="flex items-center py-3 mt-4 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onDeviceDetail()">
                  <i class="fas fa-calendar-alt text-purple-600"></i>
                  <span class="mx-4 font-medium">Device</span>
                  <i class="fas fa-caret-down ml-auto"></i>
              </a>
              <a class="flex items-center py-3 px-6 mt-10 lg:mt-56 text-white bg-purple-600 rounded-lg hover:bg-purple-700" href="https://penguinhealth.ca/">
                  <i class="fas fa-external-link-alt mx-8"></i>
                  <span class="mx-0 font-medium text-center">Visit More</span>
              </a>
          </nav>
      </div>
      <div class="flex-1 p-4 lg:pt-2">
        <div class="bg-white flex items-center justify-center min-h-screen p-4 md:p-10">
          <div class="bg-white rounded-lg shadow-lg p-4 md:p-6 w-full max-w-3xl">
            <div class="text-center mb-4 mt-5">
              <img alt="Atlas Track Logo" class="mx-auto mb-4 lg:w-80 lg:h-40 md:w-48 md:h-40" src="assets/companyLogo.png"/>
            </div>
            
            <div class="flex flex-col md:flex-row justify-between items-center mb-3">
              <p class="title mt-1 text-center md:text-left">Auto-reader Values</p>
              <a class="printbtn text-white px-16 py-2 shadow-lg mt-2 md:mt-0" href="https://penguinhealth.ca/">
                Visit More
              </a>
            </div>
            
            <hr class="border-t-2 border-purple-600 mb-6"/>
            
            <div class="title mb-6">
              <p>Results</p>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label class="fieldsHeading">Start Time</label>
                <input class="w-full p-2 fields mt-2" type="datetime-local" [(ngModel)]="startDateTime" (change)="onStartDateTimeChange($event)" step="1"/>
              </div>
              
              <div>
                <label class="fieldsHeading">End Time</label>
                <input class="w-full p-2 fields mt-2" type="datetime-local" [(ngModel)]="endDateTime" (change)="onEndDateTimeChange($event)" step="1"/>
              </div>
        
              <div>
                <label class="fieldsHeading">Well Number</label>
                <app-customcombobox 
                  [items$]="wellNumbers$" 
                  placeholder="Type Or Select Well Number" 
                  (selectionChange)="onWellNumberSelected($event)"
                  [hasError]="hasError('wellNumber')"
                ></app-customcombobox>
              </div>
        

              <div>
                <label class="fieldsHeading">Serial Number</label>
                <input 
                  type="text" 
                  class="w-full p-2 fields mt-2 fields" 
                  [class.border-red-500]="hasError('serialNumber')"
                  [class.border-2]="hasError('serialNumber')"
                  placeholder="Enter Serial Number" 
                  [(ngModel)]="initialSerialNumber"
                /> -->
              <!-- <app-customcombobox [items$]="serialNumbers$" initialValue="{{initialSerialNumber}}" placeholder="Type or select a serial number" (selectionChange)="onSerialNumberSelected($event)"></app-customcombobox> -->

              <!-- </div>
        
              <div>
                <label class="fieldsHeading">Result</label>
                <app-customcombobox 
                  [items$]="results$" 
                  placeholder="Type Or Select Result" 
                  (selectionChange)="onResultSelected($event)"
                  [hasError]="hasError('result')"
                ></app-customcombobox>
              </div>
            </div>
        
            <h2 class="text-lg font-bold text-gray-700 mb-4">User Values</h2>
            <hr class="border-t-2 border-purple-600 mb-6"/>
        
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">


            <div>
              <label class="fieldsHeading">BI Type</label>
              <input 
                type="text" 
                class="w-full p-2 fields mt-2 fields" 
                [class.border-red-500]="hasError('biType')"
                [class.border-2]="hasError('biType')"
                placeholder="Enter BI Type" 
                [(ngModel)]="initialBIType"
              /> -->
              <!-- <app-customcombobox [items$]="biTypes$" initialValue="{{initialBIType}}" placeholder="Select BI Type" (selectionChange)="onBITypeSelected($event)"></app-customcombobox> -->

            <!-- </div>
        
              <div class="flex items-center lg:mt-5">
                <label class="fieldsHeading mr-2">Control</label>
                <input class="form-checkbox h-4 w-4 ml-4" type="checkbox" [(ngModel)]="formData.control"/>
              </div>


              <div>
                <label class="fieldsHeading">BI Lot Number</label>
                <app-customcombobox 
                  [items$]="biLotNumbers$" 
                  placeholder="Type Or Select BI Lot Number" 
                  (selectionChange)="onBiLotNumberSelected($event)"
                  [hasError]="hasError('biLotNumber')"
                ></app-customcombobox>
              </div>
        
                <div>
                <label class="fieldsHeading">Sterilizer Model</label>
                <app-customcombobox 
                  [items$]="sterilizerModels$" 
                  placeholder="Type Or Select Sterilizer Model" 
                  (selectionChange)="onSterilizerModelSelected($event)"
                  [hasError]="hasError('sterilizerModel')"
                ></app-customcombobox>
              </div>


                   <div>
                  <label class="fieldsHeading">Load Number</label>
                  <app-customcombobox 
                    [items$]="loadNumbers$" 
                    placeholder="Type Or Select Load Number" 
                    (selectionChange)="onLoadNumberSelected($event)"
                    [hasError]="hasError('loadNumber')"
                  ></app-customcombobox>
                </div>
        
              <div class="flex items-center lg:mt-5">
                <label class="fieldsHeading mr-2">Implant</label>
                <input class="form-checkbox h-4 w-4 ml-4" type="checkbox" [(ngModel)]="formData.implant"/>
              </div>
        
              <div>
                <label class="fieldsHeading">Team Member</label>
                <app-customcombobox 
                  [items$]="technicians$" 
                  placeholder="Type Or Select Team Member" 
                  (selectionChange)="onTechnicianSelected($event)"
                  [hasError]="hasError('technician')"
                ></app-customcombobox>
              </div>


                   <div>
                  <label class="fieldsHeading">Cycle Type / Cycle Parameters</label>
                  <app-customcombobox 
                    [items$]="cycleCounts$" 
                    placeholder="Type Or Select Cycle Type" 
                    (selectionChange)="onCycleTypeSelected($event)"
                    [hasError]="hasError('cycleType')"
                  ></app-customcombobox>
                </div>
                        
              
              <div>
                <label class="fieldsHeading">Chemical Integrator/Indicator</label>
                <app-customcombobox 
                  [items$]="chemicalIntegrators$" 
                  placeholder="Type Or Select Chemical Integrator" 
                  (selectionChange)="onChemicalIntegratorSelected($event)"
                  [hasError]="hasError('chemicalIntegrator')"
                ></app-customcombobox>
              </div>
            </div>
         -->
            <!-- <div class="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-10 mt-10 mb-10">
              <button class="printbtn text-white px-20 py-2" (click)="generatePDF()">Print</button>
              <button class="printbtn text-white px-20 py-2" (click)="onSave()">Save</button> -->
              <!-- <button class="closebtn text-white px-20 py-2" (click)="onCloseClick()">Home</button> -->
            <!-- </div>
          </div>
        
          <app-notification-popup [isOpen]="showPopup" [message]="popupMessage" [type]="popupType" (onClose)="closePopup()"></app-notification-popup>
        </div>
      </div>
  </div>
</div> -->



<div class="maincontainer font-sans">
  <!-- Transparent overlay layer - shown only when settings popup is open -->
  <div *ngIf="showSettings" class="fixed inset-0 bg-opacity-30 z-10" (click)="closeSettings()"></div>
  
  <div class="flex flex-col md:flex-row h-screen">
    <!-- Mobile Header with Menu Toggle -->
    <div class="block md:hidden bg-white p-4 shadow-sm">
      <div class="flex items-center justify-between">
        <img alt="Atlas Track Logo" class="h-8" src="assets/newui/atlasnewlogo.png"/>
        <button class="text-gray-600" (click)="toggleMenu()">
          <i class="fas fa-bars text-xl"></i>
        </button>
      </div>
    </div>

    <!-- Sidebar - Hidden on mobile by default, shown when toggled -->
    <div class="w-full md:w-80 bg-white p-4   sidebar-menu" [ngClass]="{'hidden': !menuOpen, 'block': menuOpen, 'md:block': true}">
      <div class="flex items-center justify-center h-12 md:h-16 mb-6">
          <img alt="Atlas Track Logo" class="max-w-full h-auto" src="assets/newui/atlasnewlogo.png" width="180"/>
      </div>
      <div class="mt-4 md:mt-10">
          <a class="flex items-center py-2 px-4 md:px-8 hover:bg-purple-50 hover:rounded-lg text-gray-900 hover:text-purple-700 cursor-pointer" (click)="onHomeClick()">
              <i class="fas fa-th-large mr-3"></i>
              <span>Home</span>
          </a>
          
          <!-- Reports Dropdown Menu -->
          <div class="relative">
              <!-- Reports Menu Header -->
              <a class="flex items-center py-2 px-4 md:px-8 text-gray-600 mt-3 hover:bg-purple-50 hover:rounded-lg hover:text-purple-700 cursor-pointer" (click)="toggleReportsDropdown()">
                  <i class="fas fa-file-alt mr-3"></i>
                  <span>Download Reports</span>
                  <i class="fas fa-caret-down ml-auto" [ngClass]="{'transform rotate-180': reportsDropdownOpen}"></i>
              </a>
              
              <!-- Dropdown Items -->
              <div class="pl-8 md:pl-12 overflow-hidden transition-all duration-300" [ngClass]="{'max-h-0': !reportsDropdownOpen, 'max-h-48': reportsDropdownOpen}">
                  <a class="flex  items-center py-3 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onBILOGReport()">
                      <i class="fas fa-file-alt mr-3"></i>
                      <span>Biological Indicator Report</span>
                  </a>
                  <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onUltrasonicReport()">
                      <i class="fas fa-file-alt mr-3"></i>
                      <span>Ultrasonic/Washer Report</span>
                  </a>
                  <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onWaterTestReport()">
                      <i class="fas fa-file-alt mr-3"></i>
                      <span>Waterline Test Report</span>
                  </a>
              </div>
          </div>
          
          <a class="flex  items-center py-2 mt-3 px-4 md:px-8 text-gray-600 hover:bg-purple-50 hover:text-purple-700 hover:rounded-lg" (click)="onDeviceDetail()">
              <i class="fas fa-database mr-3"></i>
              <span>Biological Indicator Device</span>
          </a>
      </div>
  </div>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Header -->
      <header class="flex items-center justify-between h-16 md:h-24 px-4 md:px-6 bg-white shadow-sm md:shadow-none">
        <div class="flex items-center">
          <h1 class="text-gray-600 text-sm font-medium">
            Dashboard / Biological Indicator Log
          </h1>
        </div>
        <div class="flex items-center">
          <div class="relative">
          </div>
          <div class="flex items-center gap-2 md:gap-4">
            <i class="fas fa-bell text-gray-400 mr-2 md:mr-4"></i>
          
            <div class="relative">
              <div class="flex items-center gap-2 cursor-pointer z-20" (click)="toggleSettings($event)">
                <img alt="User Avatar" class="rounded-full w-8 h-8 md:w-10 md:h-10" src="assets/newui/demoprofile.png" />
                <span class="text-gray-600 hidden sm:inline">{{username}}</span>
                <i class="fas fa-caret-down ml-auto"></i>
              </div>
              
              <!-- Setting popup with relative positioning and higher z-index -->
              <div *ngIf="showSettings" class="bg-white shadow-xl rounded-lg p-3 absolute right-0 top-full mt-2 z-20 w-48 md:w-64">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onManageAccount()">
                  <img src="assets/newui/icons/manageAccountIcon.png" class="w-4 h-4" alt="">
                  <p class="text-sm"> Manage Account </p>
                </div>
                <hr class="mt-2">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onForgetPassword()">
                  <img src="assets/newui/icons/changePasswordIcon.png" class="w-4 h-4 mt-1" alt="">
                  <p class="text-sm"> Change Password </p>
                </div>
                <!-- <hr class="mt-2">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer">
                  <img src="assets/newui/icons/activityLogIcon.png" class="w-4 h-4 mt-1" alt="">
                  <p class="text-sm"> Activity Log </p>
                </div> -->
                <hr class="mt-2">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onLogoutClick()">
                  <img src="assets/newui/icons/logoutIcon.png" class="w-5 h-4 mt-1" alt="">
                  <p class="text-sm"> Logout </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- Main Section -->
      <main class="flex-1 p-4 md:p-6 overflow-auto">
        <p class="font-bold text-xl md:text-2xl mb-4 md:ml-4">Biological Indicator Log</p>
        <div class="bg-white min-h-screen p-4">
          <div class="bg-white rounded-lg shadow-lg p-4 md:p-6 w-full">
            
            <div class="flex flex-col md:flex-row mb-8">
              <p class="text-lg font-bold mb-4 md:mb-0 md:w-1/3">Auto-reader Values</p>
              
              <div class="flex flex-col sm:flex-row gap-2 md:ml-auto">
                <button class="printbtn text-white text-sm px-6 py-1 shadow-md cursor-pointer hover:shadow-xl" (click)="generatePDF()">
                  Print
                  <i class="fas fa-print text-white ml-2"></i>
                </button>
                <button class="visitmorebtn text-gray bg-gray-300 px-6 text-sm py-1 shadow-lg" href="https://penguinhealth.ca/">
                  Visit More
                </button>
              </div>
            </div>
            
            <div class="title mb-6">
              <p>Results</p>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div>
                <label class="fieldsHeading">Start Time</label>
                <input class="w-full p-3 md:p-3 fields mt-2" type="datetime-local" [(ngModel)]="startDateTime" (change)="onStartDateTimeChange($event)" step="1"/>
              </div>
              
              <div>
                <label class="fieldsHeading">End Time</label>
                <input class="w-full p-3 md:p-3 fields mt-2" type="datetime-local" [(ngModel)]="endDateTime" (change)="onEndDateTimeChange($event)" step="1"/>
              </div>
        
              <div>
                <label class="fieldsHeading">Well Number</label>
                <app-customcombobox 
                  [items$]="wellNumbers$" 
                  placeholder="Type Or Select Well Number" 
                  (selectionChange)="onWellNumberSelected($event)"
                  [hasError]="hasError('wellNumber')"
                ></app-customcombobox>
              </div>
        
              <div>
                <label class="fieldsHeading">Serial Number</label>
                <input 
                  type="text" 
                  class="w-full p-3 md:p-3 fields mt-2" 
                  [class.border-red-500]="hasError('serialNumber')"
                  [class.border-2]="hasError('serialNumber')"
                  placeholder="Enter Serial Number" 
                  [(ngModel)]="initialSerialNumber"
                /> 

                <div *ngIf="hasError('serialNumber')" class="text-red-500 text-sm mt-1">
                  {{ errorMessages['serialNumber'] }}  <span class="font-bold ml-2 cursor-pointer" (click)="onDeviceDetail()">Click here to set</span>
                </div>
              </div>
        
              <div>
                <label class="fieldsHeading">Result</label>
                <app-customcombobox 
                  [items$]="results$" 
                  placeholder="Type Or Select Result" 
                  (selectionChange)="onResultSelected($event)"
                  [hasError]="hasError('result')"
                ></app-customcombobox>
              </div>
            </div>
        
            <h2 class="title mb-6">User Values</h2>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label class="fieldsHeading">BI Type</label>
                <input 
                  type="text" 
                  class="w-full p-3 md:p-3 fields mt-2" 
                  [class.border-red-500]="hasError('biType')"
                  [class.border-2]="hasError('biType')"
                  placeholder="Enter BI Type" 
                  [(ngModel)]="initialBIType"
                />

                <div *ngIf="hasError('biType')" class="text-red-500 text-sm mt-1">
                  {{ errorMessages['biType'] }} <span class="font-bold ml-2 cursor-pointer" (click)="onDeviceDetail()">Click here to set</span>
                </div>
              </div>
        
              <div class="flex items-center mt-4 md:mt-8">
                <label class="fieldsHeading mr-2">Control</label>
                <input class="form-checkbox h-4 w-4 ml-4" type="checkbox" [(ngModel)]="formData.control"/>
              </div>

              <div>
                <label class="fieldsHeading">BI Lot Number</label>
                <app-customcombobox 
                  [items$]="biLotNumbers$" 
                  placeholder="Type Or Select BI Lot Number" 
                  (selectionChange)="onBiLotNumberSelected($event)"
                  [hasError]="hasError('biLotNumber')"
                ></app-customcombobox>
              </div>
        
              <div>
                <label class="fieldsHeading">Sterilizer Model</label>
                <app-customcombobox 
                  [items$]="sterilizerModels$" 
                  placeholder="Type Or Select Sterilizer Model" 
                  (selectionChange)="onSterilizerModelSelected($event)"
                  [hasError]="hasError('sterilizerModel')"
                ></app-customcombobox>
              </div>

              <div>
                <label class="fieldsHeading">Load Number</label>
                <app-customcombobox 
                  [items$]="loadNumbers$" 
                  placeholder="Type Or Select Load Number" 
                  (selectionChange)="onLoadNumberSelected($event)"
                  [hasError]="hasError('loadNumber')"
                ></app-customcombobox>
              </div>
        
              <div class="flex items-center mt-4 md:mt-8">
                <label class="fieldsHeading mr-2">Implant</label>
                <input class="form-checkbox h-4 w-4 ml-4" type="checkbox" [(ngModel)]="formData.implant"/>
              </div>
        
              <div>
                <label class="fieldsHeading">Team Member</label>
                <app-customcombobox 
                  [items$]="technicians$" 
                  placeholder="Type Or Select Team Member" 
                  (selectionChange)="onTechnicianSelected($event)"
                  [hasError]="hasError('technician')"
                ></app-customcombobox>
              </div>

              <div>
                <label class="fieldsHeading">Cycle Type / Cycle Parameters</label>
                <app-customcombobox 
                  [items$]="cycleCounts$" 
                  placeholder="Type Or Select Cycle Type" 
                  (selectionChange)="onCycleTypeSelected($event)"
                  [hasError]="hasError('cycleType')"
                ></app-customcombobox>
              </div>
                    
              <div>
                <label class="fieldsHeading">Chemical Integrator/Indicator</label>
                <app-customcombobox 
                  [items$]="chemicalIntegrators$" 
                  placeholder="Type Or Select Chemical Integrator" 
                  (selectionChange)="onChemicalIntegratorSelected($event)"
                  [hasError]="hasError('chemicalIntegrator')"
                ></app-customcombobox>
              </div>
            </div>
        
            <div class="flex flex-col sm:flex-row gap-4 mt-10 mb-6">
              <button class="printbtn text-white px-8 py-2" (click)="onSave()">Save</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>

  <app-notification-popup [isOpen]="showPopup" [message]="popupMessage" [type]="popupType" (onClose)="closePopup()"></app-notification-popup>
</div>